import React from 'react';

const PeopleIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="27"
      height="20"
      viewBox="0 0 27 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_715_33719)">
        <path
          d="M13.1992 9.125C15.1367 9.125 16.7305 7.59375 16.7305 5.6875C16.7305 3.78125 15.1367 2.25 13.1992 2.25C11.2617 2.25 9.66797 3.78125 9.66797 5.6875C9.66797 7.59375 11.2617 9.125 13.1992 9.125ZM13.1992 3.6875C14.3555 3.6875 15.3242 4.59375 15.3242 5.71875C15.3242 6.84375 14.3867 7.75 13.1992 7.75C12.0117 7.75 11.0742 6.84375 11.0742 5.71875C11.0742 4.59375 12.043 3.6875 13.1992 3.6875Z"
          fill="#EEF7FF"
        />
        <path
          d="M21.043 10.625C22.7305 10.625 24.0742 9.3125 24.0742 7.65625C24.0742 6 22.6992 4.6875 21.043 4.6875C19.3867 4.6875 18.0117 6 18.0117 7.65625C18.0117 9.3125 19.3867 10.625 21.043 10.625ZM21.043 6.125C21.9492 6.125 22.668 6.8125 22.668 7.6875C22.668 8.5625 21.9492 9.25 21.043 9.25C20.1367 9.25 19.418 8.5625 19.418 7.6875C19.418 6.8125 20.1367 6.125 21.043 6.125Z"
          fill="#EEF7FF"
        />
        <path
          d="M21.1992 10.9375H20.918C19.9805 10.9375 19.0742 11.2188 18.293 11.6875C17.4492 10.5625 16.1055 9.8125 14.6055 9.8125H11.8242C9.26172 9.84375 7.23047 11.875 7.23047 14.4062V16.6562C7.23047 17.25 7.69922 17.7188 8.29297 17.7188H25.0742C25.668 17.7188 26.168 17.2188 26.168 16.625V15.875C26.1367 13.1562 23.918 10.9375 21.1992 10.9375ZM8.63672 16.3125V14.4062C8.63672 12.6562 10.0742 11.2188 11.8242 11.2188H14.6055C16.3555 11.2188 17.793 12.6562 17.793 14.4062V16.3125H8.63672ZM24.7305 16.3125H19.168V14.4062C19.168 13.9062 19.0742 13.4063 18.918 12.9375C19.4805 12.5313 20.168 12.3438 20.8867 12.3438H21.168C23.1055 12.3438 24.6992 13.9375 24.6992 15.875V16.3125H24.7305Z"
          fill="#EEF7FF"
        />
      </g>
      <path
        d="M13.4688 9.125C11.5313 9.125 9.9375 7.59375 9.9375 5.6875C9.9375 3.78125 11.5313 2.25 13.4688 2.25C15.4063 2.25 17 3.78125 17 5.6875C17 7.59375 15.4063 9.125 13.4688 9.125ZM13.4688 3.6875C12.3125 3.6875 11.3438 4.59375 11.3438 5.71875C11.3438 6.84375 12.2813 7.75 13.4688 7.75C14.6563 7.75 15.5938 6.84375 15.5938 5.71875C15.5938 4.59375 14.625 3.6875 13.4688 3.6875Z"
        fill="#EEF7FF"
      />
      <path
        d="M5.625 10.625C3.9375 10.625 2.59375 9.3125 2.59375 7.65625C2.59375 6 3.96875 4.6875 5.625 4.6875C7.28125 4.6875 8.65625 6 8.65625 7.65625C8.65625 9.3125 7.28125 10.625 5.625 10.625ZM5.625 6.125C4.71875 6.125 4 6.8125 4 7.6875C4 8.5625 4.71875 9.25 5.625 9.25C6.53125 9.25 7.25 8.5625 7.25 7.6875C7.25 6.8125 6.53125 6.125 5.625 6.125Z"
        fill="#EEF7FF"
      />
      <path
        d="M5.46875 10.9375H5.75C6.6875 10.9375 7.59375 11.2188 8.375 11.6875C9.21875 10.5625 10.5625 9.8125 12.0625 9.8125H14.8438C17.4062 9.84375 19.4375 11.875 19.4375 14.4062V16.6562C19.4375 17.25 18.9688 17.7188 18.375 17.7188H1.59375C1 17.7188 0.5 17.2188 0.5 16.625V15.875C0.53125 13.1562 2.75 10.9375 5.46875 10.9375ZM18.0312 16.3125V14.4062C18.0312 12.6562 16.5938 11.2188 14.8438 11.2188H12.0625C10.3125 11.2188 8.875 12.6562 8.875 14.4062V16.3125H18.0312ZM1.9375 16.3125H7.5V14.4062C7.5 13.9062 7.59375 13.4063 7.75 12.9375C7.1875 12.5313 6.5 12.3438 5.78125 12.3438H5.5C3.5625 12.3438 1.96875 13.9375 1.96875 15.875V16.3125H1.9375Z"
        fill="#EEF7FF"
      />
      <defs>
        <clipPath id="clip0_715_33719">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6.66797)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PeopleIconDark;
